import { render, staticRenderFns } from "./EditOffRoad.vue?vue&type=template&id=00cf7a9a&scoped=true"
import script from "./EditOffRoad.vue?vue&type=script&lang=js"
export * from "./EditOffRoad.vue?vue&type=script&lang=js"
import style0 from "./EditOffRoad.vue?vue&type=style&index=0&id=00cf7a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cf7a9a",
  null
  
)

export default component.exports